// // import { useState, useEffect } from 'react';
// import { BiSolidTrashAlt, BiPlus } from "react-icons/bi";

// const AddressInputSection = ({ onAddressesChange, addresses, setAddresses }) => {
//   // Initialize with one empty address if empty
//   // useEffect(() => {
//   //   if (addresses.length === 0) {
//   //     const initialAddress = { label: '', address: '' };
//   //     setAddresses([initialAddress]);
//   //     onAddressesChange([initialAddress]);
//   //   }
//   // }, [addresses.length]);

//   const handleAddAddress = () => {
//     const newAddress = { label: '', address: '' };
//     const updatedAddresses = [...addresses, newAddress];
//     setAddresses(updatedAddresses);
//     onAddressesChange(updatedAddresses);
//   };

//   // const handleDeleteAddress = (index) => {
//   //   if (addresses.length <= 0) {
//   //     // If deleting the last address, replace with empty one instead
//   //     const emptyAddress = { label: '', address: '' };
//   //     setAddresses([emptyAddress]);
//   //     onAddressesChange([emptyAddress]);
//   //   } else {
//   //     const updatedAddresses = addresses.filter((_, i) => i !== index);
//   //     setAddresses(updatedAddresses);
//   //     onAddressesChange(updatedAddresses);
//   //   }
//   // };

//   const handleDeleteAddress = (index) => {
//     const updatedAddresses = addresses.filter((_, i) => i !== index);
//     setAddresses(updatedAddresses);
//     onAddressesChange(updatedAddresses);
//   };

//   const handleUpdateAddress = (index, field, value) => {
//     const updatedAddresses = addresses.map((addr, i) =>
//       i === index ? { ...addr, [field]: value } : addr
//     );
//     setAddresses(updatedAddresses);
//     onAddressesChange(updatedAddresses);
//   };

//   const shouldShowAddButton = () => {
//     if (addresses.length === 0) return true;
//     const lastAddress = addresses[addresses.length - 1];
//     return lastAddress?.label && lastAddress?.address;
//   };

//   return (
//     <div className="mt-10">
//       <div className="space-y-5">
//         {addresses.map((address, index) => (
//           <div key={index} className="flex flex-col space-y-3 shadow-md mt-7 px-5 py-8 border rounded-lg">
//             <div className="flex justify-between items-center">
//               <label className="text-sm font-semibold poppins-medium text-[#404040]">
//                 Address {index + 1}
//               </label>
//               {addresses.length > 0 && (
//                 <button
//                   onClick={() => handleDeleteAddress(index)}
//                   className="mx-2 text-red-700"                
//                 >
//                   <BiSolidTrashAlt size={"18px"} />
//                 </button>
//               )}
//             </div>

//             <div className="flex md:flex-row flex-wrap lg:flex-nowrap flex-col gap-6">
//               <div className="flex flex-col w-full md:w-[100%] lg:w-[50%]  space-y-2">
//                 <label className="text-xs poppins-medium text-[#404040]">Title</label>
//                 <input
//                   type="text"
//                   value={address.label}
//                   onChange={(e) => handleUpdateAddress(index, 'label', e.target.value)}
//                   className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
//                   placeholder="Title"
//                 />
//               </div>

//               <div className="flex flex-col w-full md:w-[100%] lg:w-[50%]  space-y-2">
//                 <label className="text-xs poppins-medium text-[#404040]">Address</label>
//                 <input
//                   type="text"
//                   value={address.address}
//                   onChange={(e) => handleUpdateAddress(index, 'address', e.target.value)}
//                   className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
//                   placeholder="Enter Address"
//                 />
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {(addresses.length === 0 || shouldShowAddButton()) && (
//         <button
//           onClick={handleAddAddress}
//           className="mt-5 w-full xl:w-auto flex items-center justify-center poppins-medium text-xs bg-[#dba9ae] text-[#8B2433] px-4 py-2 rounded-3xl hover:text-white hover:bg-[#8b2532] w-full"
//         >
//           <BiPlus size={"18px"} className="mr-1" />
//           {addresses.length === 0 ? 'Add Indirizzo' : 'Add Another Address'}
//         </button>
//       )}
//     </div>
//   );
// };

// export default AddressInputSection;




import { BiSolidTrashAlt, BiPlus } from "react-icons/bi";
import AddressProvinceField from "./AddressProvinceField";
import { sanitizeText } from "../../../utils/TextUtils";
import { useState } from "react";
import PropTypes from "prop-types";
import ConfirmationModal from "./ConfirmationModal";

const AddressInputSection = (props) => {
  const {
    onAddressesChange,
    addresses,
    setAddresses,
    searchQueryProvince,
    setSearchQueryProvince,
    allProvinceData,
    filteredProvinceList,
    toggleDropdownProvince,
    showOptionProvince,
    setShowOptionProvince,
  } = props;

  const [dialog, setDialog] = useState(false);

  const [selectedAddressId, setSelectedAddressId] = useState(null);

  const handleAddAddress = () => {
    const newAddress = {
      label: '',
      address: '',
      city: '',
      postal_code: '',
      province: null,
      telephone: '',
      mobile_no: '',
      email: ''
    };
    const updatedAddresses = [...addresses, newAddress];
    setAddresses(updatedAddresses);
    onAddressesChange(updatedAddresses);
  };

  // const handleDeleteAddressOld = (index) => {
  //   const updatedAddresses = addresses.filter((_, i) => i !== index);
  //   setAddresses(updatedAddresses);
  //   onAddressesChange(updatedAddresses);
  // };

  const handleDeleteAddress = (index) => {
    if (index < 0 || index >= addresses.length) return;

    const updatedAddresses = addresses.filter((_, i) => i !== index);
    setAddresses(updatedAddresses);
    onAddressesChange(updatedAddresses);
  };

  // const handleUpdateAddress = (index, field, value) => {
  //   const updatedAddresses = addresses.map((addr, i) =>
  //     i === index ? { ...addr, [field]: value } : addr
  //   );
  //   setAddresses(updatedAddresses);
  //   onAddressesChange(updatedAddresses);
  // };

  const validatePhoneNumber = (value) => {
    return /^\d*$/.test(value);
  };

  const handleUpdateAddress = (index, field, value) => {
    if (field === 'telephone' || field === 'mobile_no') {
      if (!validatePhoneNumber(value)) {
        return;
      }
    }

    const updatedAddresses = addresses.map((addr, i) =>
      i === index ? { ...addr, [field]: value } : addr
    );
    setAddresses(updatedAddresses);
    onAddressesChange(updatedAddresses);
  };


  // const handleProvinceSelectOld = (index, province) => {
  //   console.log(index, "index")
  //   const updatedAddresses = addresses.map((addr, i) =>
  //     i === index ? { ...addr, province: province } : addr
  //   );
  //   setAddresses(updatedAddresses);
  //   onAddressesChange(updatedAddresses);
  // };

  // const handleProvinceSelect = (index, provinceCode) => {
  //   console.log(index, "index", provinceCode, "provinceCode");
  //   setAddresses(prevAddresses => 
  //     prevAddresses.map((addr, i) => 
  //       i === index 
  //         ? { 
  //             ...addr, 
  //             province: addr.province === provinceCode ? null : provinceCode 
  //           } 
  //         : addr
  //     )
  //   );
  // };

  const handleProvinceSelect = (index, provinceCode) => {
    const updatedAddresses = addresses.map((addr, i) =>
      i === index
        ? {
          ...addr,
          province: addr.province === provinceCode ? null : provinceCode
        }
        : addr
    );

    setAddresses(updatedAddresses);
    onAddressesChange(updatedAddresses);
  };

  const shouldShowAddButton = () => {
    if (addresses.length === 0) return true;
    const lastAddress = addresses[addresses.length - 1];
    return lastAddress?.label &&
      lastAddress?.address &&
      lastAddress?.city &&
      lastAddress?.postal_code &&
      lastAddress?.province &&
      lastAddress?.telephone &&
      lastAddress?.mobile_no &&
      lastAddress?.email;
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        {addresses.map((address, index) => (
          <div key={index} className="flex flex-col space-y-3 p-4 border rounded-lg">
            <div className="flex justify-between items-center">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Indirizzo {index + 1}
              </label>
              {addresses.length > 0 && (
                <button
                  // onClick={() => handleDeleteAddress(index)}
                  onClick={() => {
                    setDialog(true);
                    setSelectedAddressId(index);
                  }}
                  className="mx-2 text-red-700"
                >
                  <BiSolidTrashAlt size={"18px"} />
                </button>

              )}
              <ConfirmationModal
                dialog={dialog}
                setDialog={setDialog}
                onConfirm={() => {
                  handleDeleteAddress(selectedAddressId);
                  setDialog(false);
                }}
              />
            </div>

            <div className="flex flex-wrap gap-4">
              <div className="flex flex-col md:w-[48%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                  Nome <span className="text-red-500"> *</span>
                </label>
                <input
                  type="text"
                  name="label"
                  placeholder="Nome"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={sanitizeText(address.label || "")}
                  onChange={(e) => handleUpdateAddress(index, 'label', e.target.value)}
                />
              </div>

              <div className="flex flex-col md:w-[48%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                  Indirizzo <span className="text-red-500"> *</span>
                </label>
                <input
                  type="text"
                  name="address"
                  placeholder="Indirizzo"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={sanitizeText(address.address || "")}
                  onChange={(e) => handleUpdateAddress(index, 'address', e.target.value)}
                />
              </div>

              <div className="flex flex-col md:w-[48%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                  Città <span className="text-red-500"> *</span>
                </label>
                <input
                  type="text"
                  name="city"
                  placeholder="Città"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={sanitizeText(address.city || "")}
                  onChange={(e) => handleUpdateAddress(index, 'city', e.target.value)}
                />
              </div>

              <div className="flex flex-col md:w-[23%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                  Cap <span className="text-red-500"> *</span>
                </label>
                <input
                  type="text"
                  name="postal_code"
                  placeholder="Cap"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={sanitizeText(address.postal_code || "")}
                  onChange={(e) => handleUpdateAddress(index, 'postal_code', e.target.value)}
                />
              </div>

              <AddressProvinceField
                // showOptionProvince={showOptionProvince}
                // setShowOptionProvince={setShowOptionProvince}
                // handleProvinceSelection={(province) => handleProvinceSelect(index, province)}
                // toggleDropdownProvince={toggleDropdownProvince}
                // selectedProvince={address.province}
                // setSearchQueryProvince={setSearchQueryProvince}
                // searchQueryProvince={searchQueryProvince}
                // filteredProvinceList={filteredProvinceList}
                // allProvinceData={allProvinceData}

                key={index}
                index={index}
                showOptionProvince={showOptionProvince}
                setShowOptionProvince={setShowOptionProvince}
                // handleProvinceSelection={(provinceCode) => {
                //   const updatedAddresses = addresses.map((addr, i) =>
                //     i === index ? { ...addr, province: provinceCode } : addr
                //   );
                //   setAddresses(updatedAddresses);
                // }}
                handleProvinceSelection={(province) => handleProvinceSelect(index, province)}
                toggleDropdownProvince={toggleDropdownProvince}
                selectedProvince={address.province}
                setSearchQueryProvince={setSearchQueryProvince}
                searchQueryProvince={searchQueryProvince}
                filteredProvinceList={filteredProvinceList}
                allProvinceData={allProvinceData}
              />

              {/* Destination Phone */}
              <div className="flex flex-col md:w-[48%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                  Telefono <span className="text-red-500"> *</span>
                </label>
                <input
                  type="text"
                  name="telephone"
                  placeholder="Telefono"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={address.telephone || ""}
                  onChange={(e) => handleUpdateAddress(index, 'telephone', e.target.value)}
                />
              </div>


              {/* Destination Mobile Phone */}
              <div className="flex flex-col md:w-[48%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                  Cellulare <span className="text-red-500"> *</span>
                </label>
                <input
                  type="text"
                  name="mobile_no"
                  placeholder="Cellulare"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={address.mobile_no || ""}
                  onChange={(e) => handleUpdateAddress(index, 'mobile_no', e.target.value)}
                />
              </div>


              {/* Destination Email */}
              <div className="flex flex-col md:w-[48%] w-full gap-3">
                <label className="text-sm font-semibold poppins-medium text-[#6B6B6B]">
                  Email <span className="text-red-500"> *</span>
                </label>
                <input
                  type="text"
                  name="email"
                  placeholder="Email"
                  className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={sanitizeText(address.email || "")}
                  onChange={(e) => handleUpdateAddress(index, 'email', e.target.value)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {(addresses.length === 0 || shouldShowAddButton()) && (
        <button
          onClick={handleAddAddress}
          className="flex items-center justify-center poppins-medium text-xs bg-[#dba9ae] text-[#8B2433] px-4 py-2 rounded-3xl hover:text-white hover:bg-[#8b2532] w-full"
        >
          <BiPlus size={"18px"} className="mr-1" />
          {addresses.length === 0 && 'Aggiungi Nuovo Indirizzo'}
        </button>
      )}
    </div>
  );
};
AddressInputSection.propTypes = {
  addresses: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      address: PropTypes.string,
      city: PropTypes.string,
      postal_code: PropTypes.string,
      province: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      telephone: PropTypes.string,
      mobile_no: PropTypes.string,
      email: PropTypes.string,
    })
  ).isRequired,
  setAddresses: PropTypes.func.isRequired,
  onAddressesChange: PropTypes.func.isRequired,
  searchQueryProvince: PropTypes.string,
  setSearchQueryProvince: PropTypes.func,
  allProvinceData: PropTypes.array,
  filteredProvinceList: PropTypes.array,
  toggleDropdownProvince: PropTypes.func,
  showOptionProvince: PropTypes.bool,
  setShowOptionProvince: PropTypes.func,
};

export default AddressInputSection;